import styled, { css } from 'styled-components';
import { SectionBase } from '../styles';

// Override SectionBase to remove top padding so the sticky PreviewBar sits flush
// at the top of the scroll container. The 42px is restored by HeaderArea below
// — mirrors the StylesView pattern.
export const ScrollContainer = styled(SectionBase)`
	padding-top: 0;
`;

export const HeaderArea = styled.div`
	padding-top: 42px;
`;

// Control bar placed below the page title. Sticks to the top of the scroll
// container once the title scrolls past — mirrors the FilterPills pattern on
// the Styles page. Negative horizontal margins extend it flush across the page
// while the sticky stuck background covers the section padding behind it.
export const PreviewBar = styled.div`
	position: sticky;
	top: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 62px;
	margin: 0 -62px 20px;
	background-color: ${({ theme }) => theme.gray[0]};
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const PreviewBarLabel = styled.span`
	font-size: 11px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[600]};
	text-transform: uppercase;
	letter-spacing: 0.04em;
	flex-shrink: 0;
`;

export const PreviewInput = styled.input`
	flex: 1;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;
	padding: 6px 10px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: inherit;

	&::placeholder {
		color: ${({ theme }) => theme.gray[400]};
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const BgToggle = styled.button<{ $active?: boolean }>`
	width: 22px;
	height: 22px;
	border-radius: 6px;
	border: 2px solid ${({ theme, $active }) => ($active ? theme.blue[500] : theme.gray[400])};
	flex-shrink: 0;
	transition: border-color 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const BgToggleLight = styled(BgToggle)`
	background-color: ${({ theme }) => theme.gray[0]};
`;

export const BgToggleDark = styled(BgToggle)`
	background-color: ${({ theme }) => theme.gray[900]};
`;

export const FontWarningBanner = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 6px;
	margin-bottom: 16px;
	font-size: 13px;
	line-height: 1.4;
	background: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.blue[500]};
	color: ${({ theme }) => theme.gray[800]};
`;

export const FontWarningText = styled.div`
	margin-top: 2px;
	flex: 1;
	user-select: text;
	line-height: 1.5;
	margin-bottom: 4px;
`;

export const FontWarningFontList = styled.span`
	font-weight: 600;
`;

export const FontWarningAction = styled.button<{ $queued?: boolean }>`
	flex-shrink: 0;
	font-size: 12px;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 6px;
	transition: background 0.15s ease, border-color 0.15s ease;

	${({ theme, $queued }) =>
		$queued
			? css`
					background: ${theme.gray[200]};
					border: 1px solid ${theme.gray[400]};
					color: ${theme.gray[700]};
					cursor: default;
			  `
			: css`
					background: ${theme.blue[500]};
					border: 1px solid ${theme.blue[500]};
					color: #ffffff;

					&:hover {
						background: ${theme.blue[400]};
						border-color: ${theme.blue[400]};
					}

					&:disabled {
						background: ${theme.blue[700]};
						border-color: ${theme.blue[700]};
					}
			  `}
`;
